import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ProductQuery } from "../graphql/queries";
import type {
  ProductQueryType,
  ProductQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useProductQuery = (
  options?: QueryHookOptions<ProductQueryType, ProductQueryVariablesType>
) => {
  return useQuery<ProductQueryType, ProductQueryVariablesType>(
    ProductQuery,
    options
  );
};
